// extracted by mini-css-extract-plugin
export default {"image_wrapper":"image_wrapper___Fqapw","gradient":"gradient___veT7X"};